import { createAction } from 'redux-actions';

export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAILURE = 'REGISTER_USER_FAILURE';

export const login = createAction(LOGIN_USER, (username, password, captcha) => {
    return {
        username,
        password,
        captcha
    }
})

export const register = createAction(REGISTER_USER, (username, email, password) => {
    return {
        username,
        email,
        password
    }
})